/** Longer than this → "Half Day" (exclusive of boundary). */
const HALF_DAY_MINUTES = 3 * 60;
/** Longer than this → "Full Day" (exclusive of boundary). */
const FULL_DAY_MINUTES = 5 * 60;

/**
 * Short label for cards and hero (from Rezdy `duration` / `durationMinutes`).
 * - invalid / `null` / `<= 0` → `null`
 * - longer than 5 hours → `Full Day`
 * - longer than 3 hours → `Half Day`
 * - otherwise → `40 min`, `1 hr`, `2h 30m`, etc.
 */
export function formatDurationForUi(minutes?: number | string | null): string | null {
    if (minutes == null || minutes === '') return null;
    const m = typeof minutes === 'number' ? minutes : Number(minutes);
    if (!Number.isFinite(m) || m <= 0) return null;
    const rounded = Math.round(m);
    if (rounded > FULL_DAY_MINUTES) return 'Full Day';
    if (rounded > HALF_DAY_MINUTES) return 'Half Day';
    if (rounded >= 60) {
        const h = Math.floor(rounded / 60);
        const min = rounded % 60;
        if (min === 0) return `${h} hr`;
        return `${h}h ${min}m`;
    }
    return `${rounded} min`;
}
